import { render, staticRenderFns } from "./blogPage.vue?vue&type=template&id=38d49df7"
import script from "./blogPage.vue?vue&type=script&lang=js"
export * from "./blogPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports